import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type FeedbackFlow =
    | 'firstCompletedTransaction'
    | 'firstCancelledTransaction'
    | 'none';

export interface FeedbackRootState {
    feedbackFlow: FeedbackFlow;
}

const initialState: FeedbackRootState = {
    feedbackFlow: 'none',
};

const feedbackSlice = createSlice({
    name: 'feedback',
    initialState: initialState,
    reducers: {
        setFeedbackFlow: (state, action: PayloadAction<FeedbackFlow>) => {
            return { ...state, feedbackFlow: action.payload };
        },
    },
});

export const { setFeedbackFlow } = feedbackSlice.actions;
export const feedbackReducer = feedbackSlice.reducer;
